
/* Handle Zoom Image on Back Button */
$(document).ready(function () {
  console.log('custom theme');
  const zoomCLoseButton = $(".pswp__button--close");

  /* Remove # from url */
  const removeHash = () => {
    if (window.location.href.split("").at(-1) == "#") {
      /* Just replace state so that it doesn't reload the page. */
      window.history.replaceState(
        {},
        document.title,
        window.location.href.split("#")[0]
      );
    }
  };

  /* Removes # if reload the page */
  if ($(".Product__Slideshow")) {
    removeHash();
  }

  /* Handle close button of ZoomImage */
  if (zoomCLoseButton) {
    zoomCLoseButton.click(function () {
      if (window.innerWidth < 786) {
        removeHash();
      }
      //window.history.go(-1);
    });
  }

  /* If clicked on slider then append # in url to show that modal is opened  */
  const sliderContainer = $(".pswp");
  if (sliderContainer.length > 0) {
    // $(".Product__Slideshow").click(function () {
    //   window.location.href += "#";
    // });
  }

  /* On pressing back, we remove the ZoomImage class to disable it */
  window.addEventListener(
    "hashchange",
    function () {
      // if (window.location.href.split("").at(-1) != "#") {
      //   document.querySelector(".pswp__ui")?.classList.add("pswp__ui--hidden");
      //   $(".pswp").attr("class", "pswp");
      // }
      CloseHamburger();
      if (window.innerWidth < 786) {
        if ($('#signin_popup') && $('#signin_popup').hasClass("showpopup"))
          $('#signin_popup').removeClass('showpopup');
      }
    },
    false
  );
});

/* Sort And Filter Back Button Handle */
$(document).ready(function () {
  const hamburgerMenu = document.querySelector(".header-side-menu")

  if (hamburgerMenu) {
    hamburgerMenu.addEventListener('click', () => {
      CustomOpenModalEvent();
      OpenHambuger();
    });
  }
})

$(document).ready(function(){  
  $(".st-searchIcon-mobile").click(function(){  
      $('.boost-sd__search-bar-wrapper--mobile').toggleClass("boost-sd__g-hide");
  });  
});  